import { RootState } from "../../app/state";
import { deviceTagsAdapter } from "./deviceTagsState";

// const selectRoot = (state: RootState) => state;
export const selectDeviceTagSlice = (state: RootState) => state.deviceTagList;

const deviceTagAdapterSelectors = deviceTagsAdapter.getSelectors(selectDeviceTagSlice);

export const selectAllDeviceTags = deviceTagAdapterSelectors.selectAll;